import { Create, SimpleForm, TopToolbar } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveErasmusCoordinatorsForm from "./Partials/SaveForm";

const CreateErasmusCoordinators = () => {
  return (
    <Create
      title="Добави координатор"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          <BackButtonToolbar />
        </TopToolbar>
      }
    >
      <SimpleForm>
        <SaveErasmusCoordinatorsForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateErasmusCoordinators;
